export default __webpack_public_path__ + "static/media/catedral.89833b9e.jpg";